/* accordion */
$(function() {
    $('.AccordionButton').click(function(event) {
        event.preventDefault();
        $(this)
            .parents('.Accordion')
            .next()
            .toggleClass('__active');

        $(this)
            .toggleClass('__active');


        if ($(this).hasClass('__active')) {
            $(this).find('span').text('Close');
        } else {
            $(this).find('span').text('Open');
        }
    });
});



// WEBPACK FOOTER //
// ./packages/OSB/js/modules/accordion.js